import React, { createContext, useState, useEffect, useContext, useCallback, useRef } from 'react';
import { settingsService } from '../services/settings';

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    app_title: 'OC-LANgenthal Vol. 3 - 01.01.26 - 04.01.26',
    nav_title: 'OC-LANgenthal',
    landing_hero_image: null,
    landing_gaming_image: null,
    landing_bar_image: null
  });
  const [loading, setLoading] = useState(true);
  const isFetchingRef = useRef(false);

  const loadSettings = useCallback(async () => {
    if (isFetchingRef.current) return;

    isFetchingRef.current = true;
    try {
      const result = await settingsService.getSettings();
      if (result.success) {
        setSettings(result.data);
      }
    } catch (error) {
      console.error('Failed to load settings:', error);
    } finally {
      setLoading(false);
      isFetchingRef.current = false;
    }
  }, []);

  const refreshSettings = async () => {
    await loadSettings();
  };

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  // Update browser title when settings change
  useEffect(() => {
    document.title = settings.app_title;
  }, [settings.app_title]);

  const value = {
    settings,
    loading,
    refreshSettings
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

